<app-crud-edit [apiService]="planesService" [fields]="fields" [title]="'Plan'" [description]="'En esta sección podrás editar el detalle del Plan'"></app-crud-edit>


